export const ApiReturnCodeMessages = {
  425: "Spread is not locked.",
  426: "Spread is locked by another user.",
  427: "Spread has been opened or modified in another window."
};

export const getReturnCodeMessage = (returnCode: number) =>
  ApiReturnCodeMessages[returnCode] || "Something went wrong.";



// WEBPACK FOOTER //
// ./src/api/returnCodes.ts